var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglepayLight = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 24"
}), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 24,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3C4043",
  fillRule: "evenodd",
  d: "M18.892 15.728v-3.399h1.782q1.095-.001 1.848-.716l.121-.12a2.42 2.42 0 0 0-.12-3.425 2.57 2.57 0 0 0-1.85-.73h-2.86v8.39zm0-4.429V8.37H20.7a1.472 1.472 0 0 1 1.065 2.495 1.4 1.4 0 0 1-1.065.435zm8.782-.863c-.462-.421-1.092-.636-1.89-.636q-1.538.002-2.304 1.118l.952.595q.522-.762 1.427-.762c.381 0 .75.14 1.038.394.281.241.442.589.442.957v.247c-.415-.227-.938-.348-1.581-.348q-1.127-.001-1.802.529c-.449.355-.677.823-.677 1.418a1.77 1.77 0 0 0 .637 1.405c.422.375.958.562 1.587.562.744 0 1.334-.328 1.782-.983h.047v.796h1.032v-3.54c0-.742-.228-1.33-.69-1.752m-2.927 4.235a.87.87 0 0 1-.355-.703q.002-.471.435-.782.444-.314 1.099-.315.905-.009 1.407.395-.002.683-.536 1.184a1.72 1.72 0 0 1-1.213.502 1.32 1.32 0 0 1-.837-.281m5.935 3.58 3.604-8.263h-1.173l-1.668 4.12h-.02l-1.708-4.12h-1.172l2.364 5.372-1.34 2.89z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M15.168 11.593q0-.493-.08-.976h-4.549v1.853h2.606a2.23 2.23 0 0 1-.965 1.465v1.204h1.555c.91-.836 1.433-2.074 1.433-3.546"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M10.54 16.303c1.299 0 2.398-.428 3.195-1.164l-1.554-1.204c-.436.294-.992.461-1.642.461-1.259 0-2.324-.85-2.706-1.987H6.232v1.245a4.82 4.82 0 0 0 4.307 2.65"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M7.833 12.41a2.9 2.9 0 0 1 0-1.847V9.325H6.232a4.77 4.77 0 0 0 0 4.322z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M10.54 8.576a2.6 2.6 0 0 1 1.848.723l1.38-1.378a4.66 4.66 0 0 0-3.229-1.252 4.83 4.83 0 0 0-4.307 2.656l1.601 1.245c.382-1.144 1.447-1.994 2.706-1.994"
})));
export default SvgGooglepayLight;